import InitRelatedNews from "./single-news/related-news";
import SocialMedia from "./single-news/social-media";
import Image_doodles from "./single-news/image_doodles";
import masterHeadPadding from "./single-news/master_head_padding";

jQuery(document).ready(function ($) {
    var footer_dropdowns = $('.dropdown-footer .elementor-widget-heading')
    let checkFilterPage = document.querySelectorAll('.ecf-filter-data');
    checkFilterPage.length!=0 && document.querySelector('html').classList.add('scroll-smooth');
    if (footer_dropdowns.length > 0) {
        $.each(footer_dropdowns, function (index, value) {
            console.log(index)
            console.log(value)
            $(value).on('click', function (e) {
                $(this).toggleClass('active')
                console.log($(this).next().toggle());
            })
        })
    }
});
jQuery('a[href^="#"]').on('click', function(event) {
    var target = jQuery(`${this.getAttribute('href')}`);
    let widthDevice = window.outerWidth;
    if (target.length) {
        event.preventDefault();
        if(widthDevice>1023){
            jQuery('html, body').stop().animate({
                scrollTop: target.offset().top - 100
            }, 1500);
        }else{
            setTimeout(()=>{
                jQuery('html, body').stop().animate({
                    scrollTop: target.offset().top - 100
                  }, 0);
            },100)
        }
        console.log('passed');
    }
});
window.addEventListener("orientationchange", function(event) {
    location.reload();
  });
// Single News Templates
let RelatedNews = new InitRelatedNews();
RelatedNews.init();
let SocialFloat = new SocialMedia();
SocialFloat.init();
let Doodles = new Image_doodles();
Doodles.init();
let MasterHead = new masterHeadPadding();
MasterHead.init();

jQuery('.facebook--share').click(function(event) {
    event.preventDefault();
    let u=location.href,t=document.title;
    window.open(
        'http://www.facebook.com/sharer.php?u='+encodeURIComponent(u)+'&t='+encodeURIComponent(t),
        'sharer',
        'toolbar=0,status=0,width=626,height=436');
    return false;
})
let $copyText = jQuery('.copy_text')
$copyText.click(function (e) {
    e.preventDefault();
    let $ = jQuery
    let $this = $(this);
    let copyText = $this.attr('data-href');

    document.addEventListener('copy', function(e) {
        e.clipboardData.setData('text/plain', copyText);
        e.preventDefault();
    }, true);
    let textInner = $this.find('p');
    console.log(textInner)
    $(textInner).html('Copied')
    document.execCommand('copy');
});
$copyText.mouseleave(function (e){
    let $ = jQuery
    let $this = $(this);
    let textInner = $this.find('p');
    $(textInner).html('Copy Link')
})

